import clsx from "clsx";
import _ from "lodash";
import React, { useMemo, useState } from "react";

import Icon from "~/components/common/icon";
import { Select } from "~/components/common/select";

import styles from "./index.module.scss";

// @ts-ignore
const icons: any = {
  СДЭК: (
    <svg
      width="145"
      height="41"
      viewBox="0 0 145 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7199 30.4706H16.4674C6.71351 30.4706 13.7997 9.75397 22.0113 9.75397H31.8903C33.4742 9.75397 36.267 10.0458 37.6426 6.12752L39.7684 0.041748H26.2213C18.8851 0.041748 13.1744 2.62612 9.04778 6.96119C1.91992 14.3808 -0.49771 25.9688 1.21131 31.5127C2.83696 36.6397 7.2554 40.0161 14.1748 40.0995L19.552 40.1411H26.1796L27.8053 35.2642C29.0141 31.8045 26.3047 30.4706 22.7199 30.4706ZM98.8338 21.8838L100.876 15.2562H79.0758C75.4494 15.2562 73.8237 16.2566 73.1985 18.3407L71.156 24.9684H92.9564C96.5828 24.9684 98.2085 23.968 98.8338 21.8838ZM67.9047 33.5552L65.8622 40.1828H87.6626C91.2474 40.1828 92.9147 39.1824 93.54 37.0983L95.5825 30.4706H73.7821C70.1973 30.4706 68.5716 31.471 67.9047 33.5552ZM103.919 6.71109L105.962 0.0834308H84.1612C80.5348 0.0834308 78.9091 1.08383 78.2839 3.168L76.2414 9.79566H98.0418C101.627 9.79566 103.252 8.79526 103.919 6.71109ZM70.9893 8.04496C70.0722 1.87582 66.7792 0.0834308 58.776 0.0834308H44.1869L35.6835 24.9684H41.0606C44.2702 24.9684 45.8959 25.0101 47.6049 20.4249L51.148 9.75397H56.5668C61.1937 9.75397 60.1516 15.548 57.8173 21.1752C55.7332 26.1355 52.1067 30.5123 47.7299 30.5123H38.6847C35.0582 30.5123 33.3909 31.5127 32.7239 33.5969L30.473 40.2245H37.1007L43.6033 40.1828C49.3556 40.1411 54.0658 39.7243 59.568 34.764C65.4037 29.4702 72.1564 15.8814 70.9893 8.04496ZM144.269 0.041748H131.639L119.759 12.6718C118.383 14.1307 116.966 15.5896 115.59 17.2987H115.465L121.384 0.041748H111.089L97.2081 40.1828H107.504L111.922 27.5528L116.507 23.6762L120.134 35.0975C121.259 38.6405 122.427 40.1828 124.928 40.1828H132.806L124.719 17.7572L144.269 0.041748Z"
        fill="#00B33C"
      />
    </svg>
  ),
  "Яндекс Доставка": (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 255.3 52"
      xmlSpace="preserve"
    >
      <circle cx="24" cy="24" r="24" fill="#FC3F1D" />
      <path
        fill="#FFFFFF"
        d="M27.2,13.6H25c-4.1,0-6.2,2.1-6.2,5.1c0,3.4,1.5,5,4.5,7.1l2.5,1.7l-7.2,10.8h-5.4l6.5-9.6
	c-3.7-2.7-5.8-5.3-5.8-9.6c0-5.5,3.8-9.2,11.1-9.2h7.2v28.5h-5V13.6z"
      />
      <path
        d="M64.5,49.4v-7.5h18.1v7.5h5.9V37h-3.4V5.8h-21l-0.5,14.9C63.3,29.2,62.7,34.2,61,37h-2.3v12.4H64.5z M69.1,21.5l0.4-10.8
	h9.4V37h-12C68,34.5,68.8,30,69.1,21.5z M101.9,15.2c-6.8,0-11.5,4.8-11.5,13.6c0,8.7,4.7,13.6,11.5,13.6s11.6-4.8,11.6-13.6
	C113.5,20.1,108.7,15.2,101.9,15.2z M101.9,37.5c-3.4,0-5.1-2.7-5.1-8.7c0-6.1,1.7-8.7,5.1-8.7s5.2,2.6,5.2,8.7
	S105.4,37.5,101.9,37.5z M128.9,42.4c2.9,0,4.9-0.5,6.4-1.6v-5c-1.6,1.1-3.4,1.8-6,1.8c-4.4,0-6.2-3.4-6.2-8.8
	c0-5.7,2.2-8.6,6.3-8.6c2.4,0,4.7,0.8,6,1.6v-5.2c-1.3-0.7-3.6-1.2-6.7-1.2c-7.9,0-12,5.7-12,13.6C116.6,37.6,120.6,42.4,128.9,42.4
	z M158.6,20.6v-4.9h-20.7v4.9h7.3v21.3h6.2V20.6H158.6z M180.2,24.1c0-6.3-3.2-8.7-9.8-8.7c-4.1,0-7.3,1.3-9.2,2.4V23
	c1.7-1.2,5.3-2.6,8.5-2.6c3,0,4.3,1,4.3,3.8v1.5h-1c-9.5,0-13.7,3.1-13.7,8.4s3.2,8.3,8,8.3c3.6,0,5.2-1.2,6.4-2.4h0.3
	c0.1,0.7,0.3,1.6,0.5,2.1h6c-0.2-2.1-0.3-4.3-0.3-6.4V24.1z M174.1,35.7c-0.8,1.1-2.2,2.1-4.4,2.1c-2.6,0-3.9-1.6-3.9-3.9
	c0-3.1,2.1-4.2,7.4-4.2h0.9V35.7z M195.5,41.9c6.1,0,9.8-2.6,9.8-7.6c0-3.4-2.1-5.4-5.6-6c2.8-0.8,4.6-2.8,4.6-5.9
	c0-4.5-3-6.7-8.7-6.7h-10.4v26.2C185.2,41.9,195.5,41.9,195.5,41.9z M194.7,20.4c2.2,0,3.5,0.9,3.5,2.9c0,1.8-1.3,2.9-3.7,2.9h-3.1
	v-5.8C191.4,20.4,194.7,20.4,194.7,20.4z M194.9,30.8c2.6,0,4,0.9,4,3.1c0,2.4-1.6,3.3-4,3.3h-3.4v-6.4
	C191.5,30.8,194.9,30.8,194.9,30.8z M224.8,41.9h7l-9.9-14.1l8.7-12.1h-6.2l-8.7,12.1V15.7h-6.2v26.2h6.2V29L224.8,41.9z
	 M252.9,24.1c0-6.3-3.2-8.7-9.8-8.7c-4.1,0-7.3,1.3-9.2,2.4V23c1.7-1.2,5.3-2.6,8.5-2.6c3,0,4.3,1,4.3,3.8v1.5h-1
	c-9.5,0-13.7,3.1-13.7,8.4s3.2,8.3,8,8.3c3.6,0,5.2-1.2,6.4-2.4h0.3c0.1,0.7,0.3,1.6,0.5,2.1h6c-0.2-2.1-0.3-4.3-0.3-6.4V24.1z
	 M246.7,35.7c-0.8,1.1-2.2,2.1-4.4,2.1c-2.6,0-3.9-1.6-3.9-3.9c0-3.1,2.1-4.2,7.4-4.2h0.9V35.7z"
      />
    </svg>
  ),
  ПЭК: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      width="1978px"
      height="492px"
      version="1.1"
      viewBox="0 0 131 33"
    >
      <defs />
      <g id="Слой_x0020_1">
        <metadata id="CorelCorpID_0Corel-Layer" />
        <g id="_749731344">
          <path
            className="fil0"
            fill="#262067"
            d="M0 32l11 0 0 -22 13 0 0 22 11 0 0 -31c-1,0 -31,0 -35,0l0 31z"
          />
          <path
            className="fil0"
            fill="#262067"
            d="M40 1c0,1 1,7 1,8 1,0 4,0 5,0 2,0 4,0 6,0 2,0 10,0 11,0 0,1 0,2 0,3l-14 0 0 8c1,1 11,0 14,0l0 3c-4,2 -18,0 -22,1l-2 8c10,1 21,1 30,0 2,0 2,0 2,0 2,-2 3,-13 3,-16 0,-3 -1,-13 -3,-15 -14,-2 -18,-1 -31,0z"
          />
          <path
            className="fil0"
            fill="#262067"
            d="M78 32l11 0 0 -12 4 0 8 10c1,1 1,2 2,2l13 0c-1,-1 -13,-16 -13,-17 2,-2 12,-13 12,-14 -3,0 -7,0 -11,0 -2,0 -2,0 -4,3 -1,2 -3,3 -4,5 -1,1 -2,2 -2,3 -1,0 -3,0 -5,0l0 -11 -11 0 0 31z"
          />
          <path
            className="fil1"
            fill="#D40542"
            d="M120 3l0 7c4,0 7,0 11,0l0 -8c0,0 0,0 0,-1l0 0c-2,-1 -5,0 -7,0 -5,0 -4,-1 -4,2z"
          />
          <path
            className="fil1"
            fill="#D40542"
            d="M121 31c4,1 6,0 10,0 0,-1 0,-6 0,-8 -2,0 -9,0 -10,0 -1,2 -1,6 0,8z"
          />
          <path
            className="fil2"
            fill="#BC1444"
            d="M121 31c-1,-2 -1,-6 0,-8 1,0 8,0 10,0 0,2 0,7 0,8 -4,0 -6,1 -10,0zm10 1c0,-1 0,-8 0,-9l-11 0 0 7c0,2 0,2 1,2 2,0 4,0 5,0 1,0 2,0 3,0 0,0 1,0 2,0z"
          />
        </g>
      </g>
    </svg>
  ),
  "Деловые линии": (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1000"
      height="152"
      viewBox="0 0 1000 152"
    >
      <defs />
      <path
        id="Прямоугольник_1_копия_2"
        data-name="Прямоугольник 1 копия 2"
        className="cls-1"
        fill="#000000"
        fillRule="evenodd"
        d="M428.233,81.483c-21.231,0-31.339,13.085-31.339,27.763,0,15.269,9.819,27.768,31.339,27.768,9.391,0,31.054-4.362,31.054-27.768C459.287,93.987,449.6,81.483,428.233,81.483Zm-0.146,43.755c-12.271,0-17.474-7.123-17.474-15.843,0-9.595,5.924-15.994,17.474-15.994,13,0,17.472,6.4,17.472,15.994C445.559,120.878,437.046,125.238,428.087,125.238ZM679.963,82.792H620.755V94.567h52.424Zm-339.974,0H280.78V94.567H333.2ZM280.78,136.284h28.737l6.645-11.769H280.78v11.769Zm0-32.7V115.35h40.578l6.792-11.769H280.78Zm74.809-20.79-30.473,53.492h15.017l20.074-35.319,20.221,35.319h15.739L365.7,82.792h-10.11ZM264,124.515l-30.472-53.5h-10.4l-30.472,53.5H185v27.47h12.13v-15.7h62.39v15.7h12.135v-27.47H264Zm-56.18,0,20.071-35.326,20.227,35.326h-40.3Zm642.556-20.934H822.5V82.792H809.792v53.492H822.5V115.35h27.874v20.934h12.714V82.792H850.374v20.79Zm-335.5,1.148c3.364-1.454,6.226-3.755,6.226-9.582,0-11.053-9.233-12.356-15.743-12.356H470.98v53.492h34.96c16.021,0,19.348-8.865,19.348-17.008C525.288,110.11,520.119,106.315,514.869,104.729Zm-31.321-10.6h20.358c3.037,0,4.342,1.6,4.342,4.651,0,3.2-2.027,4.8-4.342,4.8H483.548V94.128ZM505.94,124.95H483.548V113.462H505.94c3.6,0,6.2.874,6.2,5.672C512.142,122.913,510.563,124.95,505.94,124.95Zm248.1-7.7V82.792H741.326v53.492h10.7l30.615-34.74v34.74h12.71V82.792H784.666ZM988.738,82.792l-30.045,34.741V82.792H945.984v53.492h10.687l30.622-35.028v35.028H1000V82.792H988.738Zm-98.506,34.741V82.792H877.525v53.492H888.21l30.624-35.028v35.028h12.707V82.792H920.278ZM695.571,82.792L665.09,136.284h15.022l20.078-35.319,20.216,35.319h15.749L705.679,82.792H695.571ZM593.745,136.284h12.566V82.792H593.745v53.492Zm-23.979-34.3H550.42V82.792H537.707v53.492h31.924c8.658,0,17.613-4.793,17.613-17.439C587.244,102.268,575.69,101.979,569.766,101.979Zm-0.723,22.971H550.42V113.027h18.623c2.169,0,5.493.586,5.493,5.963C574.536,123.929,571.794,124.95,569.043,124.95Zm51.712-21.369V115.35h40.581l6.786-11.769H620.755Zm0,32.7H649.5l6.647-11.769H620.755v11.769Z"
      />
      <path
        id="Прямоугольник_1_копия"
        data-name="Прямоугольник 1 копия"
        className="cls-2"
        fill="#ffb02e"
        fillRule="evenodd"
        d="M17.245,106.607l67.964,13.072,5.271-9.14L30.07,84.385ZM48.7,52.114l52.852,39.262,5.276-9.139L61.51,29.908ZM32.924,79.439L93.337,105.6,98.693,96.3,45.832,57.073ZM78.776,0L64.516,24.709l45.313,52.317,6.7-11.615ZM0,136.482H75.51l6.7-11.605-67.96-13.066ZM119.808,105.9l17.65,30.584h20.088l-37.738-65.4-37.749,65.4h20.095Z"
      />
    </svg>
  ),
};

export default function PointsTk({
  points,
  pointId,
  selectedPayment,
  onSelectPoint,
  isBallon,
}: any) {
  const [q, setQ] = useState("");
  const [selectedTks, setSelectedTks]: any = useState([]);

  const tks = useMemo(() => {
    const tks: any = {};
    points.forEach((point: any) => {
      tks[point.TITLE] = tks[point.TITLE] ? 0 : tks[point.TITLE] + 1;
    });
    return Object.keys(tks).map((tk) => {
      return { name: tk, value: tk };
    });
  }, [points]);

  const filteredPoints = useMemo(() => {
    let pointFiltered = _.cloneDeep(points);
    if (q) {
      pointFiltered = pointFiltered.filter((point: any) => {
        return point.NAME.toLowerCase().includes(q.toLowerCase());
      });
    }
    if (selectedTks.length > 0) {
      pointFiltered = pointFiltered.filter((point: any) => {
        return selectedTks.includes(point.TITLE);
      });
    }
    return pointFiltered;
  }, [points, q, selectedTks]);

  // @ts-ignore
  // @ts-ignore
  return (
    <div className={clsx(isBallon && styles.ListBallon, styles.List)}>
      {!isBallon && (
        <div className={styles.Filters}>
          <div className={styles.Search}>
            <input
              placeholder="Поиск по адресу"
              value={q}
              onChange={(event) => setQ(event.target.value)}
            />
            <Icon
              id="search"
              stroke="rgb(204, 204, 204)"
              strokeWidth={2}
              size={24}
            />
          </div>
          {tks.length > 1 && (
            <div className={styles.Filter}>
              <Select
                options={tks}
                selected={selectedTks}
                onChange={(val: any) => {
                  if (selectedTks.includes(val)) {
                    setSelectedTks(
                      selectedTks.filter(
                        (setSelectedTk: any) => setSelectedTk !== val,
                      ),
                    );
                  } else {
                    setSelectedTks([...selectedTks, val]);
                  }
                }}
                placeholder="Фильтр по транспортной компании"
              />
            </div>
          )}
        </div>
      )}
      {filteredPoints.length === 0 && (
        <div>Не найдено адресов по заданным фильтрам</div>
      )}
      <div className={styles.Items}>
        {filteredPoints.map((shop: any) => (
          <div
            key={`${shop.ID}_${pointId}_${selectedPayment}`}
            className={styles.Item}
          >
            <div className={styles.Info}>
              <div className={styles.Title}>
                {icons[shop.TITLE] ? icons[shop.TITLE] : shop.TITLE}
              </div>
              <div className={styles.Address}>{shop.NAME}</div>
              <div className={styles.Time}>{shop.WORK_TIME}</div>
            </div>
            <div className={styles.Buttons}>
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
              <div
                className={clsx(
                  styles.Button,
                  // eslint-disable-next-line eqeqeq
                  pointId == shop.ID &&
                    selectedPayment?.CODE === "ONLINE" &&
                    styles.ButtonActive,
                )}
                onClick={() => {
                  onSelectPoint(shop.ID, shop.PRICE);
                }}
              >
                <div className={styles.Icon}>
                  <svg
                    width="22"
                    height="16"
                    viewBox="0 0 22 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 6H1M10 10H5M1 4.2L1 11.8C1 12.9201 1 13.4802 1.21799 13.908C1.40973 14.2843 1.71569 14.5903 2.09202 14.782C2.51984 15 3.07989 15 4.2 15L17.8 15C18.9201 15 19.4802 15 19.908 14.782C20.2843 14.5903 20.5903 14.2843 20.782 13.908C21 13.4802 21 12.9201 21 11.8V4.2C21 3.0799 21 2.51984 20.782 2.09202C20.5903 1.7157 20.2843 1.40974 19.908 1.21799C19.4802 1 18.9201 1 17.8 1L4.2 1C3.0799 1 2.51984 1 2.09202 1.21799C1.7157 1.40973 1.40973 1.71569 1.21799 2.09202C1 2.51984 1 3.07989 1 4.2Z"
                      stroke="#1247A5"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <div className={styles.Info}>
                  <span className={styles.PointName}>Онлайн оплата</span>
                  <span className={styles.Price}>{shop.PRICE} руб</span>
                </div>
              </div>
              {shop.PRICE_DOP && (
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                <div
                  className={clsx(
                    styles.Button,
                    // eslint-disable-next-line eqeqeq
                    pointId == shop.ID &&
                      selectedPayment?.CODE === "CASH" &&
                      styles.ButtonActive,
                  )}
                  onClick={() => {
                    onSelectPoint(shop.ID, shop.PRICE_DOP, "CASH");
                  }}
                >
                  <div className={styles.Icon}>
                    <svg
                      width="23"
                      height="16"
                      viewBox="0 0 23 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.5 6V10M17.5 6V10M1.5 4.2L1.5 11.8C1.5 12.9201 1.5 13.4802 1.71799 13.908C1.90973 14.2843 2.21569 14.5903 2.59202 14.782C3.01984 15 3.57989 15 4.7 15L18.3 15C19.4201 15 19.9802 15 20.408 14.782C20.7843 14.5903 21.0903 14.2843 21.282 13.908C21.5 13.4802 21.5 12.9201 21.5 11.8V4.2C21.5 3.0799 21.5 2.51984 21.282 2.09202C21.0903 1.7157 20.7843 1.40974 20.408 1.21799C19.9802 1 19.4201 1 18.3 1L4.7 1C3.5799 1 3.01984 1 2.59202 1.21799C2.2157 1.40973 1.90973 1.71569 1.71799 2.09202C1.5 2.51984 1.5 3.07989 1.5 4.2ZM14 8C14 9.38071 12.8807 10.5 11.5 10.5C10.1193 10.5 9 9.38071 9 8C9 6.61929 10.1193 5.5 11.5 5.5C12.8807 5.5 14 6.61929 14 8Z"
                        stroke="#1247A5"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className={styles.Info}>
                    <span className={styles.PointName}>
                      Оплата при получении
                    </span>
                    <span className={styles.Price}>{shop.PRICE_DOP} руб</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
